// store/auth.js

// import * as dashboard from './user';
import axios from "axios";
import { apis } from '../../apis/admin';
// import router from "../../../router/index";

const state = {
    // Additional state if needed
    bankAccounts: [],
    unitAccounts: [],
    margeaccount: '',
    getInvoices: [],
    budget: [],
    incomeItems: '',
    expenseItems: {},
    netPosition: {},
    getFolderById: '',
    // Report data
    budgets: [],
    income: [],
    expenses: [],
    netResults: [],
    statementOfCashMovements: [],
}

const mutations = {
    SET_BANK_ACCOUNTS(state, accounts) {
        state.bankAccounts = accounts;
    },
    SET_UNIT_ACCOUNTS(state, accounts) {
        state.unitAccounts = accounts;
    },
    SET_MERGE_ACCOUNTS(state, accounts) {
        state.margeaccount = accounts;
    },
    SET_INVOICES_DATA(state, invoices) {
        // Ensure all invoices have a valid status
        state.getInvoices = invoices.map(inv => ({
        ...inv,
        status: inv.status || 'unpaid'
        }));
    },
    SET_BUDGET(state, budget) {
        state.budget = budget;
    },
    SET_INCOME_ITEMS(state, income) {
        state.incomeItems = income;
    },
    SET_EXPENSE_ITEMS(state, expenses) {
        state.expenseItems = expenses;
    },
    SET_NET_POSITION_ITEMS(state, data) {
        state.netPosition = data;
    },
    // SET_FOLDER_BY_ID(state, data) {
    //     state.getFolderById = data
    // },
    SET_REPORT_DATA(state, data) {
      // When no budget exists for the requested year, the API returns an
      // empty array instead of the usual { budgets, income, ... } shape.
      state.budgets = data?.budgets?.[0];
      state.income = data?.income || [];
      state.expenses = data?.expenses || [];
      state.netResults = data?.netResults || [];
      state.statementOfCashMovements = data?.statementOfCashMovements || [];
    }
}

const actions = {
    // Additional actions if needed
    async getAccounts({ commit }, payload) {
        // console.log('getAccounts payload', payload)
            try {
                const res = await axios.get(`account/get-accounts/${payload.adminId}`, {
                    headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                    "ngrok-skip-browser-warning": "69420",
                    },
                });

                const data = res.data?.data;

                commit('SET_BANK_ACCOUNTS', data?.bankAccounts || []);
                commit('SET_UNIT_ACCOUNTS', data?.unitAccounts || []);
                commit('SET_MERGE_ACCOUNTS', data?.margeaccount || {});

            } catch (err) {
                if (err.response) {
                    console.error('Failed to fetch accounts:', err.response.statusText, err.response.data);
                } else {
                    console.error('Failed to fetch accounts: Network or server error', err.message);
                }
            }
    },
    getInvoices({ commit }, id) {
            // return
            // return new Promise((resolve, reject) => {
                axios
                    .get(axios.defaults.baseURL + apis.GET_INVOICE + id, {
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("token"),
                            "ngrok-skip-browser-warning": "69420",
                        },
                    })
                    .then((res) => {
                        console.log('getInvoices---res !!', res)
                        if(Array.isArray(res.data.data)){
                            commit('SET_INVOICES_DATA', res.data.data)
                        }
                        else{
                           commit('SET_INVOICES_DATA', res.data.message)
                        }
                    })
                    .catch((err) => {
                        console.log('getInvoices err', err)
                    })
            // })
    },

    // getFolderById({ commit }, id) {
    //     // return
    //     // return new Promise((resolve, reject) => {
    //         axios
    //             .get(axios.defaults.baseURL + apis.GET_FOLDER_BY_ID + id, {
    //                 headers: {
    //                     Authorization: "Bearer " + localStorage.getItem("token"),
    //                     "ngrok-skip-browser-warning": "69420",
    //                 },
    //             })
    //             .then((res) => {
    //                 console.log('getFolderById---res !!', res)
    //                 if(res.data.data){
    //                     commit('SET_FOLDER_BY_ID', res.data.data)
    //                 }
    //                 else{
    //                    commit('SET_FOLDER_BY_ID', res.data.message)
    //                 }
    //             })
    //             .catch((err) => {
    //                 console.log('getFolderById err', err)
    //             })
    //     // })
    // },

    createInvoice({dispatch}, payload) {
        console.log("payload--", payload);
        // return
           // Add common fields
           var formData = new FormData();
            formData.append("adminId", payload.adminId || "");
            formData.append("userId", payload.userId || "");

                   
            // Handle multipleInvoice-specific fields
            if (payload.multipleInvoice === "multipleInvoice") {
                    // Handle unitId (array of units)
                payload.unitId.forEach(unit => {
                    formData.append("unitId[]", unit._id);
                });
                formData.append("invoiceDetails", JSON.stringify(payload.invoiceDetails) || "");
            }

            // Append singleInvoice fields if present
            if (payload.singleInvoice === "singleInvoice") {
                formData.append("unitId[]", payload.unitId || "");

                if (Array.isArray(payload.items)) {
                    payload.items.forEach((item, index) => {
                        formData.append(`singleInvoice[items][${index}][item]`, item.item || "");
                        formData.append(`singleInvoice[items][${index}][allocateTo]`, item.allocateTo || "");
                        formData.append(`singleInvoice[items][${index}][cost]`, item.cost || "");
                    });
                }
            }

            // Append externalInvoice fields if present
            if (payload.externalInvoice === 'externalInvoice') {
                // formData.append("unitId[]",  []);

                formData.append("externalInvoice[company]", payload.company || "");
                formData.append("externalInvoice[name]", payload.name || "");
                formData.append("externalInvoice[email]", payload.email || "");
                formData.append("externalInvoice[address]", payload.address || "");
                formData.append("externalInvoice[allocateTo]", payload.allocateTo || "");
                if (Array.isArray(payload.items)) {
                    payload.items.forEach((item, index) => {
                        formData.append(`externalInvoice[items][${index}][item]`, item.item || "");
                        formData.append(`externalInvoice[items][${index}][cost]`, item.cost || "");
                    });
                }
            }
        
        return new Promise((resolve, reject) => {
            axios
                .post(axios.defaults.baseURL + apis.CREATE_INVOICE, formData, {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                        "ngrok-skip-browser-warning": "69420",
                        'Content-Type': 'application/json',
                    },
                })
                .then((res) => {
                    console.log("createInvoice res", res);
                    resolve(res);
                    dispatch("checkErrorAndSendToast", [
                        res.data.message,
                        "success",
                    ]);

                    dispatch('')
                })
                .catch((err) => {
                    console.log("createInvoice err", err);
                    reject(err);
                    dispatch("checkErrorAndSendToast", [
                        err.response,
                        "error",
                    ]);
                });
        });
    },

    seedAccount({dispatch}, payload) {
        console.log("payload--", payload);
        // return
           // Add common fields
           const formData = {
                adminId: payload.adminId || "",
                year: payload.yearEnd || "",
                month: payload.startMonth || "",
            };
        
        return new Promise((resolve, reject) => {
            axios
                .post(axios.defaults.baseURL + `budget/create-budget`, formData, {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                        "ngrok-skip-browser-warning": "69420",
                        'Content-Type': 'application/json',
                    },
                })
                .then((res) => {
                    console.log("seedAccount res", res);
                    resolve(res);
                    dispatch("checkErrorAndSendToast", [
                        res.data.message,
                        "success",
                    ]);

                    dispatch('')
                })
                .catch((err) => {
                    console.log("seedAccount err", err);
                    reject(err);
                    dispatch("checkErrorAndSendToast", [
                        err.response,
                        "error",
                    ]);
                });
        });
    },


     async fetchBudgetData({ commit }, { adminId, selectedYear }) {
        try {
            const response = await axios.get(`budget`, {
                params: {
                    adminId,
                    year: selectedYear
                },
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: "Bearer " + localStorage.getItem("token"),
                    "ngrok-skip-browser-warning": "69420",
                }
            });

            const resData = response.data.data;

            // Commit budget data
            commit('SET_BUDGET', resData.budgets[0]);

            // Flatten income items
            // let incomeList = [];
            // resData.income.forEach(account => {
            //     if (account.items?.length) {
            //         incomeList.push(...account.items);
            //     }
            // });
            commit('SET_INCOME_ITEMS', resData.income);

            // Group expenses by heading
            let expenseGroups = {};
            resData.expenses.forEach(account => {
                account.headings?.forEach(heading => {
                    if (!expenseGroups[heading.heading]) {
                        expenseGroups[heading.heading] = [];
                    }
                    expenseGroups[heading.heading].push(...heading.items);
                });
            });
            commit('SET_EXPENSE_ITEMS', expenseGroups);
            commit('SET_NET_POSITION_ITEMS', resData.netPosition);
        } catch (error) {
            console.error("Error fetching budget data:", error);
        }
    },

    async fetchReportData({ commit }, { adminId, selectedYear }) {
      try {
        const res = await axios.get(`report?adminId=${adminId}&year=${selectedYear}`, {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        });
        commit('SET_REPORT_DATA', res.data.data);
      } catch (err) {
        console.error('Error fetching report:', err);
      }
    }


    // deleteFolderById({dispatch }, payload) {
    //     // return
    //     return new Promise((resolve, reject) => {
    //         axios
    //             .delete(axios.defaults.baseURL + apis.DELETE_FOLDER_BY_ID + payload.id, {
    //                 headers: {
    //                     Authorization: "Bearer " + localStorage.getItem("token"),
    //                     "ngrok-skip-browser-warning": "69420",
    //                 },
    //             })
    //             .then((res) => {
    //                 console.log('deleteFolderById---res !!', res)
    //                 resolve(res)
    //                 dispatch("checkErrorAndSendToast", [
    //                     res.data.message,
    //                     "success",
    //                 ]);
                     
    //                 dispatch('getAllFolders', payload.adminId)
    //                 dispatch('getFolderById', payload.folderId)
    //             })
    //             .catch((err) => {
    //                 reject(err)
    //                 console.log('deleteFolderById err', err)
    //                 dispatch("checkErrorAndSendToast", [
    //                     err.response,
    //                     "error",
    //                 ]);
    //             })
    //     })
    // },

}

const getters = {
    // Additional getters if needed
}

export default {
    state,
    mutations,
    actions,
    getters,
  };